/**
 * Generated by orval v8.8.1 🍺
 * Do not edit manually.
 * Dashboard API
 * Admin dashboard stats (ISS-04 dashboard). Registration/like/read trend charts and status snapshots computed on read from existing entity tables — no new persisted data.

 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";

/**
 * Admin/editor only. Registration-count trends for brands/products/users/ tiktoks/review/articles, status breakdowns for brands/products/users/ tiktoks/review/articles, like/read trends for tiktoks/review/articles, distinct-login-user trend, and the latest monthly top-search-keyword snapshot.

 * @summary Get admin dashboard stats
 */
export const getDashboardStatsQueryGranularityDefault = `daily`;

export const GetDashboardStatsQueryParams = zod
    .object({
        granularity: zod
            .enum(["daily", "monthly"])
            .default(getDashboardStatsQueryGranularityDefault)
            .describe("Trend bucket size — daily covers the last 30 days, monthly the last 12 months"),
    })
    .strict();

export const getDashboardStats200ResponseDataSearchKeywordsMonthsItemTargetMonthMax = 7;

export const getDashboardStats200ResponseDataSearchKeywordsMonthsItemGroupsItemItemsItemSearchKeywordMax = 100;

export const getDashboardStats200ResponseDataSearchKeywordsMonthsItemGroupsItemItemsItemSearchLabelMax = 200;

export const GetDashboardStats200Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        data: zod
            .object({
                granularity: zod.enum(["daily", "monthly"]),
                brands: zod
                    .object({
                        total_count: zod.number().describe("Current total brand count"),
                        day_over_day_change: zod
                            .number()
                            .describe("Net change versus yesterday's total (brands created since today's start)"),
                        registration_trend: zod.array(
                            zod
                                .object({
                                    bucket: zod
                                        .string()
                                        .describe("Bucket key — YYYY-MM-DD for daily, YYYY-MM for monthly"),
                                    count: zod.number(),
                                })
                                .strict(),
                        ),
                        updates_trend: zod.array(
                            zod
                                .object({
                                    bucket: zod
                                        .string()
                                        .describe("Bucket key — YYYY-MM-DD for daily, YYYY-MM for monthly"),
                                    count: zod.number(),
                                })
                                .strict(),
                        ),
                        status_breakdown: zod
                            .record(zod.string(), zod.number())
                            .describe("brand_status value => count"),
                    })
                    .strict(),
                products: zod
                    .object({
                        total_count: zod.number().describe("Current total product count"),
                        day_over_day_change: zod
                            .number()
                            .describe("Net change versus yesterday's total (products created since today's start)"),
                        registration_trend: zod.array(
                            zod
                                .object({
                                    bucket: zod
                                        .string()
                                        .describe("Bucket key — YYYY-MM-DD for daily, YYYY-MM for monthly"),
                                    count: zod.number(),
                                })
                                .strict(),
                        ),
                        updates_trend: zod.array(
                            zod
                                .object({
                                    bucket: zod
                                        .string()
                                        .describe("Bucket key — YYYY-MM-DD for daily, YYYY-MM for monthly"),
                                    count: zod.number(),
                                })
                                .strict(),
                        ),
                        status_breakdown: zod
                            .record(zod.string(), zod.number())
                            .describe("product_status value => count"),
                        price_unset_count: zod
                            .number()
                            .describe("Products with no usable price (NULL or a lingering 0)"),
                    })
                    .strict(),
                users: zod
                    .object({
                        total_count: zod.number().describe("Current total user count"),
                        day_over_day_change: zod
                            .number()
                            .describe("Net change versus yesterday's total (users created since today's start)"),
                        registration_trend: zod.array(
                            zod
                                .object({
                                    bucket: zod
                                        .string()
                                        .describe("Bucket key — YYYY-MM-DD for daily, YYYY-MM for monthly"),
                                    count: zod.number(),
                                })
                                .strict(),
                        ),
                        updates_trend: zod.array(
                            zod
                                .object({
                                    bucket: zod
                                        .string()
                                        .describe("Bucket key — YYYY-MM-DD for daily, YYYY-MM for monthly"),
                                    count: zod.number(),
                                })
                                .strict(),
                        ),
                        status_breakdown: zod.record(zod.string(), zod.number()).describe("user_status value => count"),
                    })
                    .strict(),
                tiktoks: zod
                    .object({
                        total_count: zod
                            .number()
                            .describe("Current total post count for this board scope (non-deleted)"),
                        day_over_day_change: zod
                            .number()
                            .describe("Net change versus yesterday's total (posts created since today's start)"),
                        registration_trend: zod.array(
                            zod
                                .object({
                                    bucket: zod
                                        .string()
                                        .describe("Bucket key — YYYY-MM-DD for daily, YYYY-MM for monthly"),
                                    count: zod.number(),
                                })
                                .strict(),
                        ),
                        updates_trend: zod.array(
                            zod
                                .object({
                                    bucket: zod
                                        .string()
                                        .describe("Bucket key — YYYY-MM-DD for daily, YYYY-MM for monthly"),
                                    count: zod.number(),
                                })
                                .strict(),
                        ),
                        like_trend: zod.array(
                            zod
                                .object({
                                    bucket: zod
                                        .string()
                                        .describe("Bucket key — YYYY-MM-DD for daily, YYYY-MM for monthly"),
                                    count: zod.number(),
                                })
                                .strict(),
                        ),
                        read_trend: zod.array(
                            zod
                                .object({
                                    bucket: zod
                                        .string()
                                        .describe("Bucket key — YYYY-MM-DD for daily, YYYY-MM for monthly"),
                                    count: zod.number(),
                                })
                                .strict(),
                        ),
                        status_breakdown: zod
                            .record(zod.string(), zod.number())
                            .describe("post_status value => count, scoped to this section's board_ids"),
                    })
                    .strict(),
                review: zod
                    .object({
                        total_count: zod
                            .number()
                            .describe("Current total post count for this board scope (non-deleted)"),
                        day_over_day_change: zod
                            .number()
                            .describe("Net change versus yesterday's total (posts created since today's start)"),
                        registration_trend: zod.array(
                            zod
                                .object({
                                    bucket: zod
                                        .string()
                                        .describe("Bucket key — YYYY-MM-DD for daily, YYYY-MM for monthly"),
                                    count: zod.number(),
                                })
                                .strict(),
                        ),
                        updates_trend: zod.array(
                            zod
                                .object({
                                    bucket: zod
                                        .string()
                                        .describe("Bucket key — YYYY-MM-DD for daily, YYYY-MM for monthly"),
                                    count: zod.number(),
                                })
                                .strict(),
                        ),
                        like_trend: zod.array(
                            zod
                                .object({
                                    bucket: zod
                                        .string()
                                        .describe("Bucket key — YYYY-MM-DD for daily, YYYY-MM for monthly"),
                                    count: zod.number(),
                                })
                                .strict(),
                        ),
                        read_trend: zod.array(
                            zod
                                .object({
                                    bucket: zod
                                        .string()
                                        .describe("Bucket key — YYYY-MM-DD for daily, YYYY-MM for monthly"),
                                    count: zod.number(),
                                })
                                .strict(),
                        ),
                        status_breakdown: zod
                            .record(zod.string(), zod.number())
                            .describe("post_status value => count, scoped to this section's board_ids"),
                    })
                    .strict(),
                articles: zod
                    .object({
                        total_count: zod
                            .number()
                            .describe("Current total post count for this board scope (non-deleted)"),
                        day_over_day_change: zod
                            .number()
                            .describe("Net change versus yesterday's total (posts created since today's start)"),
                        registration_trend: zod.array(
                            zod
                                .object({
                                    bucket: zod
                                        .string()
                                        .describe("Bucket key — YYYY-MM-DD for daily, YYYY-MM for monthly"),
                                    count: zod.number(),
                                })
                                .strict(),
                        ),
                        updates_trend: zod.array(
                            zod
                                .object({
                                    bucket: zod
                                        .string()
                                        .describe("Bucket key — YYYY-MM-DD for daily, YYYY-MM for monthly"),
                                    count: zod.number(),
                                })
                                .strict(),
                        ),
                        like_trend: zod.array(
                            zod
                                .object({
                                    bucket: zod
                                        .string()
                                        .describe("Bucket key — YYYY-MM-DD for daily, YYYY-MM for monthly"),
                                    count: zod.number(),
                                })
                                .strict(),
                        ),
                        read_trend: zod.array(
                            zod
                                .object({
                                    bucket: zod
                                        .string()
                                        .describe("Bucket key — YYYY-MM-DD for daily, YYYY-MM for monthly"),
                                    count: zod.number(),
                                })
                                .strict(),
                        ),
                        status_breakdown: zod
                            .record(zod.string(), zod.number())
                            .describe("post_status value => count, scoped to this section's board_ids"),
                    })
                    .strict()
                    .describe("board_id in (beauty_news, editorial_reviews, expert_reviews)"),
                beauty_news: zod
                    .object({
                        status_breakdown: zod
                            .record(zod.string(), zod.number())
                            .describe("post_status value => count, scoped to this single board_id"),
                    })
                    .strict()
                    .describe(
                        "Per-board post_status breakdown (articles.status_breakdown combines all 3 article boards, which has no single filterable list page — this is the single-board breakdown for the beauty_news list page's status filter links)",
                    ),
                editorial_reviews: zod
                    .object({
                        status_breakdown: zod
                            .record(zod.string(), zod.number())
                            .describe("post_status value => count, scoped to this single board_id"),
                    })
                    .strict(),
                expert_reviews: zod
                    .object({
                        status_breakdown: zod
                            .record(zod.string(), zod.number())
                            .describe("post_status value => count, scoped to this single board_id"),
                    })
                    .strict(),
                logins: zod
                    .object({
                        total_count: zod
                            .number()
                            .describe("Distinct users with at least one successful login, all-time"),
                        day_over_day_change: zod
                            .number()
                            .describe("Distinct users who logged in successfully today so far"),
                        registration_trend: zod
                            .array(
                                zod
                                    .object({
                                        bucket: zod
                                            .string()
                                            .describe("Bucket key — YYYY-MM-DD for daily, YYYY-MM for monthly"),
                                        count: zod.number(),
                                    })
                                    .strict(),
                            )
                            .describe("Distinct successful-login-user count per bucket (not cumulative)"),
                    })
                    .strict(),
                search_keywords: zod
                    .object({
                        months: zod
                            .array(
                                zod
                                    .object({
                                        target_month: zod
                                            .string()
                                            .max(getDashboardStats200ResponseDataSearchKeywordsMonthsItemTargetMonthMax)
                                            .describe("Month this snapshot was generated for (YYYY-MM)"),
                                        months_ago: zod
                                            .number()
                                            .describe(
                                                "Whole calendar months before the current month this snapshot is for — 1 for last month, 2 for two months ago, etc.",
                                            ),
                                        groups: zod
                                            .array(
                                                zod
                                                    .object({
                                                        search_type: zod
                                                            .enum([
                                                                "category",
                                                                "brand",
                                                                "product",
                                                                "keyword",
                                                                "post_title",
                                                                "user",
                                                                "hashtag",
                                                            ])
                                                            .describe(
                                                                "search_histories.search_type this ranking is scoped to (category\/brand\/product\/keyword\/...) — each type is ranked independently",
                                                            ),
                                                        items: zod.array(
                                                            zod
                                                                .object({
                                                                    rank: zod.number(),
                                                                    search_keyword: zod
                                                                        .string()
                                                                        .max(
                                                                            getDashboardStats200ResponseDataSearchKeywordsMonthsItemGroupsItemItemsItemSearchKeywordMax,
                                                                        ),
                                                                    search_label: zod
                                                                        .string()
                                                                        .max(
                                                                            getDashboardStats200ResponseDataSearchKeywordsMonthsItemGroupsItemItemsItemSearchLabelMax,
                                                                        )
                                                                        .describe(
                                                                            "Resolved brand\/product\/category name (the keyword is otherwise just an id for those types); empty string for types where search_keyword is already human-readable",
                                                                        ),
                                                                    search_count: zod
                                                                        .number()
                                                                        .describe(
                                                                            "Summed search_count across all users for this keyword",
                                                                        ),
                                                                    search_url: zod
                                                                        .string()
                                                                        .describe(
                                                                            "Where this row should link to (a search\/listing\/detail page appropriate for its search_type); empty string for a type with no obvious destination",
                                                                        ),
                                                                })
                                                                .strict(),
                                                        ),
                                                    })
                                                    .strict(),
                                            )
                                            .describe(
                                                "One entry per displayed search_type (brand\/category\/keyword, fixed order), even if that type has no rows this month",
                                            ),
                                    })
                                    .strict(),
                            )
                            .describe(
                                "Up to the 3 most recent months that have a snapshot, newest first — fewer than 3 (or none) until the monthly batch has run that many times",
                            ),
                    })
                    .strict(),
            })
            .strict()
            .optional(),
    })
    .strict();

export const GetDashboardStats401Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod.number().optional(),
    })
    .strict();

export const GetDashboardStats403Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod.number().optional(),
    })
    .strict();

export const GetDashboardStats500Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod.number().optional(),
    })
    .strict();
